import type { Option } from '@contexts/shared/domain';

export enum RoleOptions {
	ADMIN = 'admin',
	DELEGATION_MANAGER = 'delegation_manager',
	ROOM_STAFF = 'room_staff',
	OPERATOR = 'operator',
	CLIENT = 'client',
	SUPPORT = 'support'
}

export type Role = `${RoleOptions}`;

export const B2B_ROLES: Role[] = [
	RoleOptions.DELEGATION_MANAGER,
	RoleOptions.ROOM_STAFF,
	RoleOptions.OPERATOR
];

export function isB2bRole(role: Role | undefined): boolean {
	return !!role && B2B_ROLES.includes(role);
}

const DELEGATIONLESS_ROLES: Role[] = [RoleOptions.ADMIN, RoleOptions.CLIENT, RoleOptions.SUPPORT];

export function isDelegationlessRole(role: Role | undefined): boolean {
	return !!role && DELEGATIONLESS_ROLES.includes(role);
}

//TODO Por el momento hago la implementación de esta función en el frontend, pero tal vez deberíamos hacerla en el backend
export const roleNames: Record<RoleOptions, string> = {
	[RoleOptions.ADMIN]: 'roles.admin',
	[RoleOptions.DELEGATION_MANAGER]: 'roles.delegationManager',
	[RoleOptions.ROOM_STAFF]: 'roles.roomStaff',
	[RoleOptions.OPERATOR]: 'roles.operator',
	[RoleOptions.CLIENT]: 'roles.client',
	[RoleOptions.SUPPORT]: 'roles.support'
};

export function getRoles(): Role[] {
	return Object.values(RoleOptions) as Role[];
}

export function getRoleOptions(): Option<Role>[] {
	return getRoles().map((role) => ({
		label: roleNames[role],
		value: role
	}));
}
